<template>
  <div>

    <Layout>
      <router-view class="view-box"/>

      <div v-if="showLazyLoader">
        <div class="simplepharm-modal">
          <div class="simplepharm-modal-content" style="width: 550px">
            <div>{{ lazyloaderModule.getProgressBarMessage }}</div>
            <b-spinner
                class="m-2"
                variant="primary"
                role="status"
            ></b-spinner>
            <div v-if="lazyloaderModule.displayProgressBar" style="width: 100%;">
              <b-progress :value="lazyloaderModule.progressBarProgress" :max="100" class="mb-4" variant="info"
                          animated></b-progress>
              {{ progressPercentage }}
            </div>

          </div>
        </div>
      </div>

    </Layout>
  </div>
</template>
<script>
import Layout from "../../layouts/main";
import {log} from "@/state/pinia/log";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule, useLazyLoaderModule} from "@/state/pinia";


export default {
  name: "OrdersManager",
  components: {
    Layout,
  },
  data() {
    return {
      showLazyLoader: false,
      dataFetched: true,
      progressPercentage: "1%",
    };
  },
  methods: {
    /**
     * Recursively checks API progress endpoint for current process GUID
     * and updates displayed elements of the progress bar.
     * Is used only if the current process GUID is not empty (we want to watch backend operation progress)
     * It is unnecessary for front-end process. For front-end process we only have to set displayProgressBar for true
     * and it will update itself
     */
    observeProgressUntilDoneRecursively() {
      var taskProgressRequest = {
        taskId: this.processGUID,
      };

      this.ordersModule.httpGetProcessProgressStatus(taskProgressRequest).then(() => {
        if (this.lazyloaderModule.getProgressBarProgress < 1.0) {
          this.observeProgressUntilDoneRecursively();
        }
      });
    },
  },
  computed: {
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    displayLazyLoader() {
      return this.lazyloaderModule.displayLazyLoader;
    },

  },
  watch: {
    displayLazyLoader: {
      handler(newVal) {
        // log.log("displayLazyLoader: " + newVal);
        if (newVal) {
          this.showLazyLoader = true;

        } else {
          this.showLazyLoader = false;
        }
      },
      deep: true,
    },
    /**
     * Observes current process progress value and renders it
     * into local progressPercentage variable, which is displayed in progressBar modal.
     */
    progressBarProgress: {
      handler(newVal) {
        let calculatedPercentageProgress = newVal.toString();
        this.progressPercentage = parseInt(calculatedPercentageProgress) + "%";
      },
      deep: true,
    },
    /**
     * Observes current process GUID. If current process GUID is present it means
     * that we want to observe backend operation process.
     */
    processGUID: {
      handler(newVal, oldVal) {
        if (newVal != oldVal) {
          if (newVal.length > 0) {
            // If new progress GUID is not empty, display progressbar and start checking the API progress endpoint
            this.observeProgressUntilDoneRecursively();
          }
        }
      },
      deep: true,
    },
  },
  created() {
    log.log("trigger refresh token")
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();

    });
  },
};
</script>
